import api from 'src/Utils/api';
export var deleteBlockedDate = function (id) { return api.delete("/booking_blocked_dates/" + id); };
